import { useMemo, useContext } from 'react';
import EditorJS from '@editorjs/editorjs';
import { Container, Grid, Button, Alert } from '@mui/material';
import Label, { formatDate } from '../../../../utils';
import Header from '@editorjs/header';
import List from "@editorjs/list";
import ImageTool from '@editorjs/image';
import style from './Post.module.css';
import _ from 'lodash';
import { useLoaderData, useNavigate } from 'react-router-dom';
import Api, { BASE_ROUTE } from '../../../../api';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import UserContext from '../../../../context/userContext';

export async function postLoader(props) {
    const id = _.get(props, 'params.id', 0);
    return Api.get(`/intranet/posts/${id}`);
}

export default function PostView2() {
    const navigate = useNavigate();
    const { roles } = useContext(UserContext);
    const data: any = useLoaderData();
    const { post } = data;

    useMemo(() => {
        const editorjsConfig: any = {
            holder: 'editorjs',
            readOnly: true,
            minHeight: 0,
            tools: {
                header: { class: Header, config: { placeholder: 'Enter a header' } },
                list: { class: List, inlineToolbar: true, config: { defaultStyle: 'unordered' } },
                image: { class: ImageTool },
            },
        };
        if (post.content) editorjsConfig.data = post.content;
        new EditorJS(editorjsConfig);
    }, []);

    return (
        <Container maxWidth="lg" className={style.articleContainer}>
            <Grid container justifyContent="center">
                <Grid item xs={12} md={9} lg={8}>
                    <Grid container justifyContent="space-between" className={style.articleToolbar}>
                        <Grid item>
                            <Button
                                variant="text"
                                startIcon={<ArrowBackIcon />}
                                className={`themeButton ${style.toolbarLink}`}
                                onClick={() => navigate(`${BASE_ROUTE}/posts`)}
                            >
                                <Label k="postPreview.backCta" />
                            </Button>
                        </Grid>
                        <Grid item>
                            {roles.isPostEditor && (
                                <Button
                                    variant="text"
                                    startIcon={<EditIcon />}
                                    className={`themeButton ${style.toolbarLink}`}
                                    onClick={() => navigate(`${BASE_ROUTE}/posts/${post.id}/edit`)}
                                >
                                    <Label k="postPreview.editCta" />
                                </Button>
                            )}
                        </Grid>
                    </Grid>

                    {!post?.is_published && (
                        <Alert severity="info" className={style.draftAlert}>
                            Denne artikkelen er ikke publisert.
                        </Alert>
                    )}

                    <article className={style.article}>
                        {post.tags?.length > 0 && (
                            <div className={style.articleKicker}>
                                {post.tags.join(' · ')}
                            </div>
                        )}

                        <h1 className={style.articleTitle}>{post.title}</h1>

                        <div className={style.articleByline}>
                            <span className={style.bylineAuthor}>
                                Av {post.authors.join(', ')}
                            </span>
                            <span className={style.bylineDot}>·</span>
                            <span className={style.bylineDate}>
                                {formatDate(post.created)}
                            </span>
                        </div>

                        <div className={style.articleRule} />

                        <div className={style.articleBody}>
                            <div id="editorjs" />
                        </div>
                    </article>
                </Grid>
            </Grid>
        </Container>
    );
}
